var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page profile-command-page" }, [
    _c("div", { staticClass: "saas-hero card-saas profile-command-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/user" } }, [
              _vm._v(_vm._s(_vm.trans("user.user"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("user.social")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(
            _vm._s(_vm.userForm.first_name) +
              " " +
              _vm._s(_vm.userForm.last_name)
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "profile-command-hero__subtitle" }, [
          _vm._v(_vm._s(_vm.trans("user.social"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nk-block" }, [
      _c(
        "div",
        { staticClass: "card-saas card-saas--flush admin-user-profile-card" },
        [
          _c("div", { staticClass: "card-aside-wrap" }, [
            _c(
              "div",
              { staticClass: "card-content" },
              [
                _c("user-sidebar", { attrs: { menu: "social", id: _vm.id } }),
                _vm._v(" "),
                _c("div", { staticClass: "card-inner admin-user-form-inner" }, [
                  _c("div", { staticClass: "nk-block" }, [
                    _c(
                      "div",
                      { staticClass: "nk-block-head admin-user-form-head" },
                      [
                        _c("h4", { staticClass: "admin-user-section-title" }, [
                          _vm._v(_vm._s(_vm.trans("user.social"))),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.submit.apply(null, arguments)
                          },
                          keydown: function ($event) {
                            return _vm.userForm.errors.clear($event.target.name)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("user.sm_profile", {
                                      name: "Facebook",
                                    })
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.facebook_profile,
                                    expression: "userForm.facebook_profile",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  value: "",
                                  name: "facebook_profile",
                                  placeholder: _vm.trans("user.sm_profile", {
                                    name: "Facebook",
                                  }),
                                },
                                domProps: {
                                  value: _vm.userForm.facebook_profile,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.userForm,
                                      "facebook_profile",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.userForm,
                                  "prop-name": "facebook_profile",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("user.sm_profile", {
                                      name: "Twitter",
                                    })
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.twitter_profile,
                                    expression: "userForm.twitter_profile",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  value: "",
                                  name: "twitter_profile",
                                  placeholder: _vm.trans("user.sm_profile", {
                                    name: "Twitter",
                                  }),
                                },
                                domProps: {
                                  value: _vm.userForm.twitter_profile,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.userForm,
                                      "twitter_profile",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.userForm,
                                  "prop-name": "twitter_profile",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("user.sm_profile", {
                                      name: "LinkedIn",
                                    })
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.linkedin_profile,
                                    expression: "userForm.linkedin_profile",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  value: "",
                                  name: "linkedin_profile",
                                  placeholder: _vm.trans("user.sm_profile", {
                                    name: "LinkedIn",
                                  }),
                                },
                                domProps: {
                                  value: _vm.userForm.linkedin_profile,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.userForm,
                                      "linkedin_profile",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.userForm,
                                  "prop-name": "linkedin_profile",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-6 form-group" },
                            [
                              _c("label", { attrs: { for: "" } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.trans("user.sm_profile", {
                                      name: "Google Plus",
                                    })
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.userForm.google_plus_profile,
                                    expression: "userForm.google_plus_profile",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  value: "",
                                  name: "google_plus_profile",
                                  placeholder: _vm.trans("user.sm_profile", {
                                    name: "Google Plus",
                                  }),
                                },
                                domProps: {
                                  value: _vm.userForm.google_plus_profile,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.userForm,
                                      "google_plus_profile",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.userForm,
                                  "prop-name": "google_plus_profile",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "admin-user-form-actions" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                              attrs: { type: "submit" },
                            },
                            [_vm._v(_vm._s(_vm.trans("general.save")))]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl",
                attrs: {
                  "data-content": "userAside",
                  "data-toggle-screen": "xxl",
                  "data-toggle-overlay": "true",
                  "data-toggle-body": "true",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-inner-group",
                    attrs: { "data-simplebar": "" },
                  },
                  [_c("user-summary", { attrs: { user: _vm.user } })],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }